import { Button } from "primereact/button";

import AlertTriangleIcon from "@/assets/icons/equipe-alert-triangle.svg?react";
import { Dialog } from "@/ds";
import styles from "./equipe-dialog.module.scss";
import type { EquipeDialogProps, EquipeDialogViewModel } from "./types-equipe-dialog";

/**
 * Moldura dos diálogos de aviso da Etapa Equipe (Figma "Warning Modal" 12227:420433, "Modal Equipe
 * Incompleta" 12227:420586): ícone de alerta, título e apoio, corpo e rodapé com Voltar à esquerda e
 * a confirmação à direita. O Figma não desenha o X: o Esc continua voltando.
 */
export function EquipeDialogView({
  dialogTestId,
  testIds,
  title,
  subtitle,
  voltarLabel,
  confirmarLabel,
  visible = true,
  rodapeLargo = false,
  onVoltar,
  onConfirmar,
  children,
}: EquipeDialogProps & EquipeDialogViewModel) {
  return (
    <Dialog
      visible={visible}
      modal
      showCloseIcon={false}
      onHide={onVoltar}
      className={styles.dialog}
      headerClassName={styles.header}
      contentClassName={styles.content}
      pt={{ footer: { className: styles.footerRoot } }}
      aria-label={title}
      data-testid={dialogTestId}
      header={
        <div className={styles.headerLeft}>
          <span className={styles.badge} aria-hidden>
            <AlertTriangleIcon />
          </span>
          <div className={styles.headerText}>
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.subtitle}>{subtitle}</p>
          </div>
        </div>
      }
      footer={
        <div className={`${styles.footer} ${rodapeLargo ? styles.footerLargo : ""}`}>
          <Button
            type="button"
            text
            label={voltarLabel}
            onClick={onVoltar}
            data-testid={testIds.voltar}
          />
          <Button
            type="button"
            label={confirmarLabel}
            onClick={onConfirmar}
            data-testid={testIds.confirmar}
          />
        </div>
      }
    >
      <div className={styles.body}>{children}</div>
    </Dialog>
  );
}
